import React, { Suspense, useMemo } from 'react';

import { DataValidationList } from './components/DataValidationList';
import { DataValidationV2TabContent } from './hooks/useDataValidationV2SearchParams';
import { DataValidationDetails } from './components/DataValidationDetails';
import { DataValidationV2Provider } from './providers/DataValidationV2Provider';
import { useCherreState } from '@cherre-frontend/data-fetching';
import { connectorDataValidationTabParam } from '../../../../recoil';
import ComingSoon from 'src/products/connector/components/ComingSoon';

class ErrorBoundary extends React.Component<
  Record<'children', React.ReactNode>,
  { hasError: boolean }
> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <ComingSoon pageName='Data Validation' />;
    }

    return this.props.children;
  }
}

export const DataValidationV2Content = () => {
  const [dataValidationV2Content] = useCherreState(
    connectorDataValidationTabParam
  );
  const content = useMemo(() => {
    switch (dataValidationV2Content?.content) {
      case DataValidationV2TabContent.DETAILS:
        return <DataValidationDetails />;
      default:
        return <DataValidationList />;
    }
  }, [dataValidationV2Content]);

  return (
    <ErrorBoundary>
      <Suspense fallback={<span />}>
        <DataValidationV2Provider>{content}</DataValidationV2Provider>
      </Suspense>
    </ErrorBoundary>
  );
};
